import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    element.style.position = "fixed";
    element.style.top = binding.value.height * 0.213 + "px";
    element.style.left = binding.value.width * 0.379 + "px";
    element.style.width = binding.value.width * 0.16 + "px";
    element.style.height = binding.value.height * 0.204 + "px";
}

const videoDirective: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default videoDirective;
